<div
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
  class="overlay"
>
  <div class="popupForChangePasswordForm xs:!w-5/6 md:!w-3/5 lg:!w-2/5 xl:!w-1/3 bg-white p-5">
    <div>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="changePassword(resetPasswordForm.value)">
        <div>
          <p class="text-text_gray_primary font-bold xs:text-sm 2xl:text-xl text-center">
            Change Password
          </p>
          <div class="relative mt-3">
            <label
              for="password"
              class="text-secondary_Light_Text_Color xs:text-xs xl:text-sm 2xl:text-base  font-medium"
              >Current Password</label
            >
            <input
              id="password"
              name="password"
              [type]="oldPassword ? 'text' : 'password'"
              formControlName="oldPassword"
              class="password-input pr-12 text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 xs:text-xs sm:text-sm  font-bold text-primary_Text_Color focus:border-blue_Color focus:outline-none focus:ring-0 input-box sm:placeholder:text-sm xs:placeholder:text-xs"
              placeholder="Enter Current Password"
              required
            />

            <button
              type="button"
              (click)="oldPasswordToggle()"
              class="absolute top-9 right-4 opacity-50"
            >
              <img
                [src]="
                  oldPassword
                    ? _commonService.Images.OPEN_EYE
                    : _commonService.Images.CLOSE_EYE
                "
                alt=""
              />
            </button>
            <div class="xs:text-xxs xl:text-sm "
              *ngIf="
                resetPasswordForm.get('oldPassword')?.invalid &&
                resetPasswordForm.get('oldPassword')?.touched
              "
            >
              <div
                *ngIf="
                  resetPasswordForm.get('oldPassword')?.hasError('required')
                "
                class="text-red-500"
              >
                Password is required
              </div>
              <div
                *ngIf="
                  resetPasswordForm.get('oldPassword')?.hasError('pattern')
                "
                class="text-red-500"
              >
                Invalid format
              </div>
            </div>
          </div>
          <div class="relative mt-4">
            <label
              for="password"
              class="text-secondary_Light_Text_Color xs:text-xs xl:text-sm 2xl:text-base   font-medium"
              >New Password</label
            >
            <input
              id="password"
              name="password"
              [type]="newPassword ? 'text' : 'password'"
              formControlName="newPassword"
              class="password-input pr-12 text-gray-dark border border-card_Bg_Color mx-auto peer  block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 xs:text-xs sm:text-sm font-bold text-primary_Text_Color focus:border-blue_Color focus:outline-none focus:ring-0 input-box sm:placeholder:text-sm xs:placeholder:text-xs"
              placeholder="Enter New Password"
              required
            />
            <button
              type="button"
              (click)="newPasswordToggle()"
              class="absolute top-9 right-4 opacity-50"
            >
              <img
                [src]="
                  newPassword
                    ? _commonService.Images.OPEN_EYE
                    : _commonService.Images.CLOSE_EYE
                "
                alt=""
              />
            </button>
            <div class="xs:text-xxs xl:text-sm"
              *ngIf="
                resetPasswordForm.get('newPassword')?.invalid &&
                resetPasswordForm.get('newPassword')?.touched
              "
            >
              <div
                *ngIf="
                  resetPasswordForm.get('newPassword')?.hasError('required')
                "
                class="text-red-500"
              >
                New Password is required
              </div>
              <div
                *ngIf="
                  resetPasswordForm
                    .get('newPassword')
                    ?.hasError('invalidPassword') && !resetPasswordForm.get('newPassword')?.hasError('required')
                "
                class="text-red-500"
              >
                Invalid Password format
              </div>
            </div>
          </div>
          <div class="relative mt-4">
            <label
              for="password"
              class="text-secondary_Light_Text_Color xs:text-xs xl:text-sm 2xl:text-base  font-medium"
              >Confirm Password</label
            >
            <input
              id="password"
              name="password"
              [type]="confirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              (keyup)="confirmPasswordMatched($event)"
              class="password-input pr-12 text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 xs:text-xs sm:text-sm font-bold text-primary_Text_Color focus:border-blue_Color focus:outline-none focus:ring-0 input-box sm:placeholder:text-sm xs:placeholder:text-xs"
              placeholder="Enter Confirm Password"
              required
            />
            <button
              type="button"
              (click)="confirmPasswordToggle()"
              class="absolute top-9 right-4 opacity-50"
            >
              <img
                [src]="
                  confirmPassword
                    ? _commonService.Images.OPEN_EYE
                    : _commonService.Images.CLOSE_EYE
                "
                alt=""
              />
            </button>
            <span
            class="text-red-600 xs:text-xxs xl:text-sm"
            *ngIf="
            resetPasswordForm.get('confirmPassword').touched &&
              resetPasswordForm.errors?.['notmatched']
            "
            >Password doesn't match
          </span>
          </div>
          <p class="text-red-500 xs:text-xxs sm:text-xs 2xl:text-sm  italic mt-2 ">
            *You will be logged out of all devices once you click on update and you will be asked to login with new password
          </p>
          <div class="flex justify-end gap-5 mt-3">
            <button *ngIf="!loginUser.isFirstTimeLogin" (click)="closePopUp()"
            class="cancel-button-animation py-2 px-4 rounded-xl xs:text-sm xl:text-sm 2xl:text-base border border-card_Bg_Color text-primary_Text_Color">
            Cancel</button>
            <button type="submit"  class="xs:text-sm xl:text-sm 2xl:text-base"  [disabled]="!(resetPasswordForm.valid && !confirmPasswordNotValid)" [ngClass]="!(resetPasswordForm.valid && !confirmPasswordNotValid)? '!bg-primary_Bg_Button_Color cursor-not-allowed text-primary_Bg_Btn_Text_color rounded-xl py-2 px-4' : 'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color rounded-xl py-2 px-4'"
            >Update</button>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
